<template>
  <div id="hello">
    <div class="row">
      <div class="col-xs-12">
        <p>Hallo</p>
      </div>
    </div>
  </div>
</template>

<script>
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
